import React from 'react'
import Layout from '../../components/Layout'
import '../index.css'
import { Link } from 'gatsby'

import diplomats_Mediator_INFP_personality_header from '../../images/personality_types_details/diplomats_Mediator_INFP_personality_header.svg'
import diplomats_Mediator_INFP_career_path from '../../images/personality_types_details/diplomats_Mediator_INFP_career_path.svg'
import circleforward from '../../images/personality_types_details/circleforward.png'
import circleback from '../../images/personality_types_details/circleback.png'

const infp_careers = () => {
    return (
        <Layout>
            <main className="q-td analyst mediator">
                {/* --------------------mobile child nav bar------------------------ */}
                <nav className="top-tabs mobile-only" aria-label="Personality description">

                    <Link to='/personality-types/mediator-infp-personality' className="tab with-progress">
                        <span className="title">Introduction</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/mediator-infp-strengths-and-weaknesses" className="tab with-progress">
                        <span className="title">Strengths and Weaknesses</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/mediator-infp-relationships-dating" className="tab with-progress ">
                        <span className="title">Romantic Relationships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab with-progress">
                        <span className="title">Friendships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/mediator-infp-parents" className="tab with-progress ">
                        <span className="title">Parenthood</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/mediator-infp-careers" className="tab with-progress active">
                        <span className="title">Career Paths</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/mediator-infps-at-work" className="tab with-progress ">
                        <span className="title">Workplace Habits</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/mediator-infp-conclusion" className="tab with-progress ">
                        <span className="title">Conclusion</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab premium">
                        <span className="title">Premium Profile</span>
                    </Link>

                </nav>
                {/* -------------------- picture and title-------------------------- */}

                <header class="type-header diplomat mediator">

                    <svg class="background" viewBox="0 0 1920 600" preserveAspectRatio="none">
                        <path class="st0" d="M400 598.9l1520-152.8v164.4H0v-288z"></path>
                        <path class="st1" d="M923.4 546.3l996.6-97.4V1.5h-851z"></path>
                    </svg>

                    <img src={diplomats_Mediator_INFP_personality_header} class="scene" alt='loading...' />
                    <div class="type-info">
                        <h1><span>Mediator</span> Personality</h1>
                        <div class="code">INFP-A / INFP-T</div>
                        <a href="#" class="difference">(What’s the difference?)</a>
                    </div>

                </header>

                {/* -------------------------side bar section------------------------------------- */}
                <div className="with-sidebars">

                    <div className="sidebar left">
                        <nav className="sections" id="sticky-sidebar" style={{ paddingTop: '50px' }}>
                            <div className="title">Explore This Type</div>
                            <ul>
                                <li className=""><Link to='/personality-types/mediator-infp-personality'>Introduction</Link></li>
                                <li className=""><Link to="/personality-types/mediator-infp-strengths-and-weaknesses">Strengths & Weaknesses</Link></li>
                                <li className=""><Link to="/personality-types/mediator-infp-relationships-dating">Romantic Relationships</Link></li>
                                <li className=""><Link to="/personality-types/mediator-infp-friends">Friendships</Link></li>
                                <li className=""><Link to="/personality-types/mediator-infp-parents">Parenthood</Link></li>
                                <li className="active"><Link to="/personality-types/mediator-infp-careers">Career Paths</Link></li>
                                <li className=""><Link to="/personality-types/mediator-infps-at-work">Workplace Habits</Link></li>
                                <li className=""><Link to="/personality-types/mediator-infp-conclusion">Conclusion</Link></li>
                                <li className="premium"><Link to="/">Premium Profile</Link></li>
                            </ul>
                        </nav>
                        <daily-insight v-cloak personality-type="INTJ"></daily-insight>
                    </div>
                    {/* ----------------------------description pages of sidebar------------------------------------- */}
                    <article class="main description">

                        <h1>Career Paths</h1>


                        <p>Many Mediators (INFPs) long for a career that doesn’t just take care of the bills but also feels fulfilling. They want to spend their days doing something they genuinely love, preferably without too much stress or drama.</p>
                        <div class="description-pullout">For Mediators, an ideal career path should feel like a calling, not just a job. And if it doesn’t involve too many draining social interactions or phone calls, so much the better.</div><p>Ever the idealists, Mediators might struggle to find a profession that meets their practical needs <em>and</em> fulfills their dreams. These personalities may drift in frustration, waiting for the perfect job to present itself and eventually feeling stuck or worried that they’re not living up to their potential.</p>
                        <div class="scene"><img alt="Mediator (INFP) careers" src={diplomats_Mediator_INFP_career_path} /></div>
                        <p>Alas, there’s no such thing as a perfect job, and the question of whether to settle for a less-than-ideal position can weigh heavily on people with this personality type. Fortunately, Mediators’ creativity, independence, and sincere desire to connect with and help others can help them shine – and find fulfillment – in nearly any line of work.</p>
                        <h2>A Place for Everyone</h2>
                        <p>Certain careers and vocations seem to hold a special allure for these personalities. With their curiosity and their love of self-expression, many Mediators dream of becoming writers. They might write novels, seek out interesting freelance niches, or even find themselves doing communications in a corporate field or for a nonprofit organization. Richly imaginative, Mediators can infuse even the driest of fundraising or marketing materials with new life.</p>
                        <div class="description-pullout">Sensitive to artistic beauty, some Mediators simply come to life in the worlds of writing, music, drama, or dance.</div><p>Although this personality type isn’t known for seeking the spotlight, other Mediators find their life purpose in the performing arts. These Mediators can draw from their inner depths to pull out exquisite interpretations of a creator’s work. They may also create their own works as playwrights, composers, or choreographers.</p>
                        <p>Whatever they do, Mediators want to feel that their work is helping others. It’s not surprising, then, that many people with this personality type choose careers that are focused on service, such as counseling, psychology, teaching, health care, social work, massage therapy, or physical rehabilitation. For these caring, supportive personalities, few things are more meaningful than seeing their work help change someone’s life for the better.</p>
                        <h2>Finding Their Way</h2>
                        <p>Mediators are adaptable, but they may find it demotivating to work in high-stress, bureaucratic, or hectic environments. They can also become frustrated by workplaces that are highly critical or competitive. Workplaces that reward independence tend to be a good fit for Mediators, although they may appreciate some structure and oversight to help them avoid procrastinating and getting lost in thought.</p>
                        <p>That said, Mediators don’t need ideal conditions to thrive professionally. These personalities want to live in tune with their values, in their careers as much as in any other aspect of their lives. They can put up with – and overcome – any number of challenges as they pursue a sense of mission in their work.</p>

                        <div class="number">06</div>


                    </article>
                </div>

                <div className="navigation-buttons comp" data-chunk="type-chunk">
                    <div className="part left">
                        <Link to='/personality-types/mediator-infp-parents' className='next-feature'>
                            Parenthood
                       <br /><br />
                            <img src={circleback} width={75} height={75} />
                        </Link>
                    </div>
                    <div className="part right">
                        <Link to='/personality-types/mediator-infps-at-work' className='next-feature'>
                            Workplace Habits
                       <br /><br />
                            <img src={circleforward} width={75} height={75} />
                        </Link>
                    </div>
                </div>

            </main>
        </Layout>
    )
}

export default infp_careers
